// Auto generated file, do not manually modify!
// com.hotpads.cometuserauth.api.getuser.web.handler.web.CometUserAuthenticationWebHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { AuthCheckUserInfoDto } from '../..';

interface GetUserParams {
  allowedSessionLengthSeconds?: number;
  pageWithSensitiveInformation?: boolean;
}

export const CometUserAuthenticationWebHandler_getUser_Path = '/api/web/v1/auth/getUser';

/**
 * Get user auth status and some details
 */
export const CometUserAuthenticationWebHandler_getUser = (getParams: GetUserParams, client = getClient()) => {
  return httpFrontEndRequest<GetUserParams, never, AuthCheckUserInfoDto>(
    {
      getParams: getParams,
      endpoint: CometUserAuthenticationWebHandler_getUser_Path,
      method: 'GET',
      contextPath: '/your-rental-api',
    },
    client,
  );
};
